import { render, staticRenderFns } from "./VChatInput.vue?vue&type=template&id=356b55ab&"
import script from "./VChatInput.vue?vue&type=script&lang=ts&"
export * from "./VChatInput.vue?vue&type=script&lang=ts&"
import style0 from "./VChatInput.vue?vue&type=style&index=0&id=356b55ab&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports